import { createAction, props } from '@ngrx/store';
import { AddressInterface } from '../networking/models/customer/requests/address';

export interface AddressModalInterface {
  city: any
  geopos: any,
  address: any,
  loading: boolean,
  editMode:boolean,
  openModal: boolean,
  reposition:boolean,
  tags: string,
  comments: string,
  nickname: string,
  deliveryTypeText: any,
  errorLoadList: boolean,
  addAfterEdit: boolean,
  addresses: AddressInterface[]
}

export const setLoading = createAction('[Address Modal] Loading Data', props<{loading: boolean}>());
export const add = createAction('[Address Modal] Add Address to list', props<{address: AddressInterface}>());
export const create = createAction('[Address Modal] create Address', props<{address: AddressInterface}>());
export const update = createAction('[Address] Update Address', props<{address: AddressInterface}>());
export const remove = createAction('[Address Modal] Remove Address', props<{idAddress: string}>());
export const removeAll = createAction('[Address Modal] Remove all Address');
export const setCustomerAddress = createAction('[Address Modal] Set address customer', props<{addresses: AddressInterface[]}>());
export const setPrediction = createAction('[Address Modal] Set Prediction', props<{prediction: any}>());
export const setPosition = createAction('[Address Modal] Set current Position', props<{geopos: any,}>());
export const editAddress = createAction('[Address Modal] Set current Address to edit', props<{address: any, city: any}>());
export const setCity = createAction('[Address Modal] Set current City', props<{city: any}>());
export const setAddress = createAction('[Address Modal] Set Address', props<{address: AddressInterface}>());
export const setAddressMarker = createAction('[Address Modal] set Marker ubication', props<{address: AddressInterface, city: any}>());
export const reposition = createAction('[Address Modal] set have to reposition', props<{sw: boolean}>());
export const openModal = createAction('[Address Modal] Open state', props<{open: boolean}>());
export const setActualPosition = createAction('[Address Modal] set Actual ubication', props<{geopos: any,}>());
export const setDeliveryTypeText = createAction('[Address Modal] set DeliveryType Text', props<{deliveryTypeText: any,}>());
export const clear = createAction('[Address Modal] clear address and city');
export const reset = createAction('[Address Modal] Reset Modal to inital state');
export const errorLoadList = createAction('[Address Modal] Error on load customer address', props<{sw: boolean}>());
export const addAfterEdit =createAction ('[Address Modal] add address after edit');
